export function customCellIdentifierRenames(
  before: string,
  after: string
): Array<[string, string]> {
  return [
    [before, after],
    [`${before}Props`, `${after}Props`]
  ]
}
